import { IdsMainButton } from "@ids/react"

import { Field, Form, HousingAlert } from "@garantidos/components"

import { useSimulationForm } from "./hooks"

import "./style.scss"

export function SimulationForm({
  isSimulationSubmitting,
  setIsSimulationSubmitting
}) {
  const {
    onSubmitCallback,
    fields,
    form,
    errorMessage,
    setErrorMessage,
    isLoading,
    handlePrevStep
  } = useSimulationForm({ setIsSimulationSubmitting })

  const { isValid, watch } = form
  const propertyValueWatch = watch("property_value")

  const { propertyValue, creditValue, financingTerm } = fields

  return (
    <>
      <HousingAlert
        message={errorMessage}
        setMessage={setErrorMessage}
        type="error"
      />

      <Form
        onSubmit={onSubmitCallback}
        form={form}
        data-testid="simulation_form"
        className="simulation-form"
      >
        <Field
          field={propertyValue}
          form={form}
          description={propertyValue.description}
          rules={propertyValue.rules}
          data-testid={propertyValue.name}
          disabled={isLoading}
        />
        <Field
          field={creditValue}
          form={form}
          description={creditValue.description(propertyValueWatch)}
          rules={creditValue.rules}
          data-testid={creditValue.name}
          disabled={isLoading}
        />
        <Field
          field={financingTerm}
          form={form}
          data-testid={financingTerm.name}
          max={20}
          min={1}
          disabled={isLoading || !propertyValueWatch}
          description={financingTerm.description}
          options={financingTerm.options}
        />
        <div>
          <IdsMainButton
            full
            className="simulation-form__submit"
            data-testid="submit"
            disabled={!isValid || isSimulationSubmitting}
            type="submit"
          >
            Simular
          </IdsMainButton>
          <IdsMainButton
            full
            className="simulation-form__back"
            variant="secondary"
            onClick={handlePrevStep}
            type="button"
          >
            Voltar
          </IdsMainButton>
        </div>
      </Form>
    </>
  )
}
